export const galleryOptions = {
    dragToClose: false,
    closeButton: 'outside',
    template: {
        closeButton: `<i class="icon-close"></i><span>CLOSE</span>`,
        main: `
            <div class="fancybox__container" role="dialog" aria-modal="true" aria-hidden="true" aria-label="{{MODAL}}" tabindex="-1">
                <div class="fancybox__backdrop"></div>
                <div class="fancybox__carousel"></div>
                <div class="mb-4"><h2 class="fancybox__title font-weight-bold"></h2></div>
                <img src="/public/site/${process.env.MIX_TEMPLATE_FOLDER}/dist/images/logo-white.svg" class="logo">
            </div>
        `,
    },
    Carousel: {
        Navigation: {
            prevTpl: `<i class="icon-arrow-slim-left">`,
            nextTpl: `<i class="icon-arrow-slim-right">`,
        }
    },
    Thumbs: {
        autoStart: false,
    },
    Toolbar: {
        display: [],
    },
    on: {
        // init: (fancybox) => {
        //     console.log(this)
        // },
        // initCarousel: (fancybox) => {
        //     console.log('initCarousel')
        //     console.log('fancybox:', fancybox)
        // },
    }
}

export default galleryOptions;